import SchoolLinksManagerOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import StudentObserverOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import { useTranslation } from 'react-i18next';

import { SidebarTypes } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';
import { AdminRoutePath } from 'applications/GSP/shared/constants/router';

import { useAdminSchoolLinksNavigationItems } from './hooks';

import type { NavigationItem } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

export const useAdminNavigationItems = (): NavigationItem[] => {
  const { t } = useTranslation();
  const adminSchoolLinksNavigationItems = useAdminSchoolLinksNavigationItems();

  return [
    {
      label: t('GSP.layouts.mainLayout.sidebar.studentObserver'),
      icon: <StudentObserverOutlinedIcon />,
      to: AdminRoutePath.StudentObserver,
      sidebarType: SidebarTypes.ADMIN,
    },
    ...adminSchoolLinksNavigationItems,
    {
      label: t('GSP.layouts.mainLayout.sidebar.schoolLinksManager'),
      icon: <SchoolLinksManagerOutlinedIcon />,
      to: AdminRoutePath.SchoolLinksManager,
      sidebarType: SidebarTypes.ADMIN,
    },
  ];
};
